package com.ustadmobile.core.domain.upload

//For use with uplaod route

const val HEADER_UPLOAD_UUID = "upload-uuid"

const val HEADER_IS_FINAL_CHUNK = "upload-final-chunk"

const val DEFAULT_CHUNK_SIZE = 512 * 1024

const val HEADER_UPLOAD_START_BYTE = "upload-start-byte"
